// import tacho from '../../images/tacho.png';


// export default function InputBusquedaArticulo({ searchTerm, handleSearchChange, clearInput }) {
//     return (
//         <div className='sticky top-0 z-10 p-1 lg:mb-10 mb-0.5 lg:-mt-28 mt-2 flex justify-center'>
//             <div className='relative w-full lg:w-96'>

//                 <input
//                     type="text"
//                     className='rounded-lg px-2 font-mono w-full border-2 border-black text-center text-xl h-11 lg:h-9 '  
//                     placeholder='BUSCAR ARTÍCULO...'
//                     autoComplete="off"
//                     value={searchTerm}
//                     onChange={handleSearchChange}
//                 />
//                 <button onClick={clearInput} className='absolute right-1 top-1/2 transform -translate-y-1/2  p-1'>
//                     <img src={tacho} alt="Tachito" className='w-11 h-9 lg:w-10 lg:h-8' />
//                 </button>
//             </div>
//         </div>
//     );

  
// }


import tacho from '../../images/tacho.png';

export default function InputBusquedaArticulo({ searchTerm, handleSearchChange, clearInput }) {
    return (
        <div className='sticky top-[calc(3.5rem+env(safe-area-inset-top))] z-40 w-full border-b border-slate-200/70 bg-slate-50/90 backdrop-blur-md dark:border-slate-800 dark:bg-slate-950/90'>
            <div className='mx-auto w-full max-w-2xl px-4 py-3 sm:px-6 lg:max-w-xl lg:py-2.5'>
                <div className='group relative'>

                    {/* Lupa */}
                    <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-4 text-slate-400 transition-colors group-focus-within:text-brand-600 dark:text-slate-500 dark:group-focus-within:text-brand-400 lg:pl-3.5">
                        <svg className="h-5 w-5 lg:h-4 lg:w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                        </svg>
                    </div>

                    <input
                        type="text"
                        inputMode="search"
                        enterKeyHint="search"
                        className='h-12 w-full rounded-xl border border-slate-200 bg-white pl-12 pr-14 text-base text-slate-900 shadow-sm outline-none transition
                                   placeholder:text-slate-400 focus:border-brand-500 focus:ring-4 focus:ring-brand-500/15
                                   dark:border-slate-700 dark:bg-slate-900 dark:text-slate-100 dark:placeholder:text-slate-500 dark:focus:border-brand-400
                                   lg:h-10 lg:pl-10 lg:text-sm'
                        placeholder='Buscar por descripción o código...'
                        autoComplete="off"
                        autoCorrect="off"
                        spellCheck="false"
                        value={searchTerm}
                        onChange={handleSearchChange}
                    />

                    {/* Botón de borrado */}
                    {searchTerm && (
                        <button
                            onClick={clearInput}
                            className='absolute inset-y-0 right-1 my-auto flex h-10 w-10 items-center justify-center rounded-lg transition hover:bg-slate-100 active:scale-90 dark:hover:bg-slate-800 lg:h-8 lg:w-8'
                            title="Limpiar búsqueda"
                            aria-label="Limpiar búsqueda"
                        >
                            <img
                                src={tacho}
                                alt=""
                                className='h-6 w-6 object-contain opacity-60 transition-opacity group-hover:opacity-90 lg:h-5 lg:w-5'
                            />
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
}
